export default __webpack_public_path__ + "static/media/arrow.d26c7eef.svg";